import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HFOptionGroup from 'components/HFInputs/HFOptionGroup'
import { booleanOptions } from 'controllers/TaskManager/formOptions'

export const TaskNeedsController = (props) => {
	const { i18n } = useGlobal()
	const { isAdministrative, requisition } = props

	return (
		<>
			{!isAdministrative ? (
				<fieldset>
					<h4>{i18n`Need for escort`}</h4>
					<HFOptionGroup
						type='boolean'
						label={i18n`Is there a need?`}
						name='needEscort'
						options={booleanOptions}
					/>
				</fieldset>
			) : requisition?.requestEscort ? (
				<fieldset>
					<h4>{i18n`Need for escort`}</h4>
					<HFOptionGroup
						type='boolean'
						label={i18n`Requires Plain?`}
						name='needsOptions.transport'
						options={booleanOptions}
					/>

					<HFOptionGroup
						type='boolean'
						label={i18n`Requires Housing?`}
						name='needsOptions.housing'
						options={booleanOptions}
					/>
				</fieldset>
			) : null}
		</>
	)
}
